"use client";

import { useQueryClient } from "@tanstack/react-query";

import { useMarkRead as useMarkReadMutation } from "@/lib/api/generated";

import { NOTIFICATIONS_KEY } from "./use-notifications";
import { UNREAD_COUNT_KEY } from "./use-unread-count";

export function useMarkRead() {
  const queryClient = useQueryClient();
  const mutation = useMarkReadMutation({
    mutation: {
      onSuccess: () => {
        queryClient.invalidateQueries({ queryKey: NOTIFICATIONS_KEY });
        queryClient.invalidateQueries({ queryKey: UNREAD_COUNT_KEY });
      },
    },
  });

  return {
    ...mutation,
    mutate: (id: string) => mutation.mutate({ notificationId: id }),
    mutateAsync: (id: string) => mutation.mutateAsync({ notificationId: id }),
  };
}
